<template>
  <div>
    <GNavBar></GNavBar>
    <h1 class="mt-5 pt-5">CourseDev</h1>
    <hr />
    <GProjectDetails :from="caller"></GProjectDetails>
  </div>
</template>

<script>
  import GProjectDetails from '@/components/GProjectDetails.vue'
  import GNavBar from '@/components/GNavBar.vue'

  export default {
    name: 'QuickLookPage',
    components: {
      GProjectDetails,
      GNavBar,
    },
    async created() {
      if (this.$route.query.caller) {
        this.caller = this.$route.query.caller
      } else {
        this.caller = 'quicklook'
      }
      if (!this.isAcademicStaff) {
        await this.$store.dispatch('getProjects')
        await this.$store.dispatch('getComments')
        this.$store.dispatch('getContracts')
      } else {
        await this.$store.dispatch('getProjectsByProgram', {
          program: this.currentUser.program_id,
        })
        await this.$store.dispatch('getCommentsByProgram', {
          program: this.currentUser.program_id,
        })
        this.$store.dispatch('getContractsByProgram', {
          program: this.currentUser.program_id,
        })
      }
      this.$store.dispatch('getOptions')
      this.$store.dispatch('getSemesters')
      this.pollData()
      this.$store.dispatch('setCurrentProjectByID', {
        id: parseInt(this.$route.params.id),
      })
    },
    beforeDestroy() {
      clearInterval(this.polling)
    },
    data() {
      return {
        polling: null,
        caller: '',
      }
    },
    computed: {
      currentUser() {
        return this.$store.getters.currentUser
      },
      currentProject() {
        return this.$store.getters.currentProject
      },
    },
    methods: {
      pollData() {
        this.polling = setInterval(() => {
          if (!this.isAcademicStaff) {
            this.$store.dispatch('getComments')
            this.$store.dispatch('getProjects')
          } else {
            this.$store.dispatch('getProjectsByProgram', {
              program: this.currentUser.program_id,
            })
            this.$store.dispatch('getCommentsByProgram', {
              program: this.currentUser.program_id,
            })
          }
        }, 120000)
      },
    },
  }
</script>
